import { OverviewContainer } from './Overview'
import { MyTasksContainer } from './MyTasks'
import { MyActiveContainer } from './MyActive'
import { ProposalsForReviewContainer } from './ProposalsForReview'
import { ProposalsToReviewContainer } from './ProposalsToReview'
import { ProposalsUpdateContainer } from './ProposalsUpdate'
import { ProposalsClientContainer } from './ProposalsClient'
import { ProposalsInReviewContainer } from './ProposalsInReview'
import { GenerateProposal } from './GenerateProposal'
import { AddOpportunity } from './AddOpportunity'
import { AddContact } from './AddContact'
import { DueToday } from './DueToday'

const DictionaryDashboard = {
  OverviewContainer,
  MyTasksContainer,
  MyActiveContainer,
  ProposalsForReviewContainer,
  ProposalsToReviewContainer,
  ProposalsUpdateContainer,
  ProposalsClientContainer,
  ProposalsInReviewContainer,
  GenerateProposal,
  AddOpportunity,
  AddContact,
  DueToday
}

const AllDashboardComponent = {
  proposalGenerator: {
    label: 'Create Proposal',
    componentName: 'GenerateProposal',
    type: 'proposalGenerator',
    width: 3,
    height: 6
  },
  trackOpportunity: {
    label: 'Track Opportunity',
    componentName: 'AddOpportunity',
    type: 'trackOpportunity',
    width: 3,
    height: 6
  },
  enterContact: {
    label: 'Enter Contact/Company',
    componentName: 'AddContact',
    type: 'enterContact',
    width: 3,
    height: 6
  },
  dueToday: {
    label: 'Due Today',
    componentName: 'DueToday',
    type: 'dueToday',
    width: 3,
    height: 6
  },
  lead: {
    label: 'Lead',
    componentName: 'OverviewContainer',
    type: 'lead',
    width: 2,
    height: 4
  },
  new: {
    label: 'New Opportunity',
    componentName: 'OverviewContainer',
    type: 'new',
    width: 2,
    height: 4
  },
  estimating: {
    label: 'Estimating Opportunity',
    componentName: 'OverviewContainer',
    type: 'estimating',
    width: 2,
    height: 4
  },
  followUp: {
    label: 'Follow-up Opportunity',
    componentName: 'OverviewContainer',
    type: 'followUp',
    width: 2,
    height: 4
  },
  won: {
    label: 'Won Opportunity',
    componentName: 'OverviewContainer',
    type: 'won',
    width: 2,
    height: 4
  },
  lost: {
    label: 'Lost Opportunity',
    componentName: 'OverviewContainer',
    type: 'lost',
    width: 2,
    height: 4
  },
  closed: {
    label: 'Closed Opportunity',
    componentName: 'OverviewContainer',
    type: 'closed',
    width: 2,
    height: 4
  },
  project: {
    label: 'Project',
    componentName: 'OverviewContainer',
    type: 'project',
    width: 2,
    height: 4
  },
  myTasks: {
    label: 'Tasks Due Today and Overdue Tasks',
    componentName: 'MyTasksContainer',
    type: null,
    width: 4,
    height: 16
  },
  myActive: {
    label: 'My Active Opportunities and Proposals by Stage',
    componentName: 'MyActiveContainer',
    type: null,
    width: 4,
    height: 11
  },
  proposalsForReview: {
    label: 'Proposals I Sent for Review',
    componentName: 'ProposalsForReviewContainer',
    type: null,
    width: 2,
    height: 8
  },
  proposalsToReview: {
    label: 'Proposals I Need to Review',
    componentName: 'ProposalsToReviewContainer',
    type: null,
    width: 2,
    height: 8
  },
  proposalsUpdate: {
    label: 'Proposals I Need to Update',
    componentName: 'ProposalsUpdateContainer',
    type: null,
    width: 2,
    height: 8
  },
  proposalsClient: {
    label: 'Proposals Ready to Send to Client',
    componentName: 'ProposalsClientContainer',
    type: null,
    width: 2,
    height: 8
  },
  proposalsInReview: {
    label: 'Proposals in Review',
    componentName: 'ProposalsInReviewContainer',
    type: null,
    width: 4,
    height: 8
  }
}

export { DictionaryDashboard, AllDashboardComponent }
